export default "declare var global: NodeJS.Global;\n";